import * as styles from "../../../../styles/DefaultSetting";
import React, { useCallback, useEffect, useState, useMemo } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAppDispatch } from "../../../../store";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import BoxMoving from "./BoxMoving";
import BoxModify from "./BoxModify";
import { BoxmanageType } from "../../../../reducer/postpayloadtypes";
import styled from "styled-components/macro";
import Modal from "../../../../components/Modal";
import GetServerInsectName from "../../PostDiary/component/GetServerInsectName";
import GetServerLifeCycleName from "../../PostDiary/component/GetServerLifeCycleName";

import { useFarms } from "hooks/farmInfo";
import test from "node:test";

const BtnBox = styled.div`
  @media screen and (max-width: 1050px) {
    width: 50%;
    display: flex;
    align-content: center;
    justify-content: space-between;
    margin-top: 20px;
    & button {
      width: 48%;
      background: #fff;
    }
  }
`;

dayjs.locale("ko");
// `/ifactory/api/diary/findBeforeDiary/${diaryId}?diaryType=${diaryType}&productCode=${productcode}`
// /277/INSECT5
const Boxmanagement = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { Targetfarms } = useFarms();
  const targetFarmInfo = JSON.parse(
    localStorage.getItem("targetfarmInfo") || "{}"
  );
  const targetFarmInfoMemo = useMemo(
    () => targetFarmInfo,
    [JSON.stringify(targetFarmInfo)]
  );

  let [alldata, setAlldata] = useState<any>(); // 전체 리스트

  let [selectdata, setSelectdata] = useState<any>(); // select상자 데이터
  let [modal, setModal] = useState<number>(0);
  let [finishDate, setFinishDate] = useState<any>([
    {
      Date: "",
    },
  ]);

  // 상자 이동 정보 state
  let [manageBox, setManageBox] = useState<any>(); // 이동할 상자 정보

  // 상자 곤충명 수정 state
  let [changeBoxInfo, setChangeBoxInfo] = useState<any>(); // 수정할 상자 정보
  const [changeBoxName, setChangeBoxName] = useState(""); // 수정할 상자 이름
  const [insect, setInsect] = useState(""); // 수정 곤충 정보

  const [changeexday, setChangeexday] = useState<any>([
    {
      Date: "",
    },
  ]);

  const [deletemodal, setDeletemodal] = useState<boolean>(false);

  const [manBoxid, setManBoxid] = useState<any>();
  const [chulmodal, setChulmodal] = useState<boolean>(false);

  const [actionComplete, setActionComplete] = useState<boolean>(false);

  const [exchangeComplete, setExchangeComplete] = useState<boolean>(false);

  let [boxName, setBoxName] = useState(""); // 수정할 상자 이름
  let [viewType, setViewType] = useState<boolean>(true);
  let [orderType, setOrderType] = useState("1");
  let [orderType1, setOrderType1] = useState<boolean>(false);
  let [orderType2, setOrderType2] = useState<boolean>(false);
  let [orderType3, setOrderType3] = useState<boolean>(false);
  let [viewBox, setViewBox] = useState<boolean>(false);
  let [subBoxId, setSubBoxId] = useState(""); // 수정할 상자 이름

  if (modal === 0) {
    document.body.style.overflow = "auto";
  } else {
    document.body.style.overflow = "hidden";
  }

  // modal을 닫을때 초기화 함수
  const closeModal = () => {
    setModal(0);
    setChangeBoxName("");
    setChangeBoxInfo("");
    setInsect("");
  };

  // 마운트 시 AllData 함수 실행
  useEffect(() => {
    AllData();
  }, []);

  // actionComplete가 true일때 AllData 함수 실행
  useEffect(() => {
    if (actionComplete) {
      AllData();
      setActionComplete(false);
    }
  }, [actionComplete]);

  const AllData = async () => {
    try {
      setViewBox(false);
      const response = await axios.get(
        `/ifactory/api/managebox?farmId=${targetFarmInfo.placeId}&boxName=${boxName}`
      );

      const sortdata: BoxmanageType[] = response.data;
      sortdata.sort((a, b) => {
        function sortType2(a: BoxmanageType, b: BoxmanageType) {
          if (a.startFarmDate < b.startFarmDate) return -1;
          if (a.startFarmDate > b.startFarmDate) return 1;

          return 0;
        }

        function sortType3(a: BoxmanageType, b: BoxmanageType) {
          if (a.expFarmDate < b.expFarmDate) return -1;
          if (a.expFarmDate > b.expFarmDate) return 1;
          return 0;
        }

        return orderType === "1"
          ? orderType1
            ? a.boxName.localeCompare(b.boxName, undefined, { numeric: true })
            : b.boxName.localeCompare(a.boxName, undefined, { numeric: true })
          : orderType === "2"
          ? orderType2
            ? sortType2(a, b) ||
              b.boxName.localeCompare(a.boxName, undefined, { numeric: true })
            : sortType2(b, a) ||
              a.boxName.localeCompare(b.boxName, undefined, { numeric: true })
          : orderType3
          ? sortType3(a, b) ||
            b.boxName.localeCompare(a.boxName, undefined, { numeric: true })
          : sortType3(b, a) ||
            a.boxName.localeCompare(b.boxName, undefined, { numeric: true });
      });

      //
      // 곤충명 & 생애주기 세팅(240320. Leo. 수정)
      // insectName, lifeCycleName 전체를 가져온 후 매핑
      const insectName = await GetServerInsectName();
      const lifeCycleName = await GetServerLifeCycleName();

      sortdata.map((item) => {
        const insectNameData = insectName?.find(
          (insect) => insect.productCode === item.productCode
        );
        const lifeCycleNameData = lifeCycleName?.find(
          (el) =>
            el.productCode === item.productCode && el.lifeCycle === item.instar
        );
        item.productName = insectNameData?.productName;
        item.instarName = lifeCycleNameData?.name;
      });

      setAlldata(sortdata);
      setSelectdata(sortdata);
    } catch (error: any) {
      // console.error(error.response.data.message);
      setAlldata([]);
      setSelectdata([]);
    }
  };

  const sortAllData = (typeValue: string) => {
    setViewBox(false);
    const sortdata: BoxmanageType[] = alldata;
    function sortType2(a: BoxmanageType, b: BoxmanageType) {
      if (a.startFarmDate < b.startFarmDate) return -1;
      if (a.startFarmDate > b.startFarmDate) return 1;

      return 0;
    }

    function sortType3(a: BoxmanageType, b: BoxmanageType) {
      if (a.expFarmDate < b.expFarmDate) return -1;
      if (a.expFarmDate > b.expFarmDate) return 1;
      return 0;
    }
    sortdata.sort((a, b) => {
      return typeValue === "1"
        ? orderType1
          ? b.boxName.localeCompare(a.boxName, undefined, { numeric: true })
          : a.boxName.localeCompare(b.boxName, undefined, { numeric: true })
        : typeValue === "2"
        ? orderType2
          ? sortType2(b, a) ||
            (orderType1
              ? b.boxName.localeCompare(a.boxName, undefined, { numeric: true })
              : a.boxName.localeCompare(b.boxName, undefined, {
                  numeric: true,
                }))
          : sortType2(a, b) ||
            (orderType1
              ? b.boxName.localeCompare(a.boxName, undefined, { numeric: true })
              : a.boxName.localeCompare(b.boxName, undefined, {
                  numeric: true,
                }))
        : orderType3
        ? sortType3(a, b) ||
          (orderType1
            ? b.boxName.localeCompare(a.boxName, undefined, { numeric: true })
            : a.boxName.localeCompare(b.boxName, undefined, { numeric: true }))
        : sortType3(b, a) ||
          (orderType1
            ? b.boxName.localeCompare(a.boxName, undefined, { numeric: true })
            : a.boxName.localeCompare(b.boxName, undefined, { numeric: true }));
    });

    setAlldata(sortdata);
    setSelectdata(sortdata);
  };

  const finishDateHandler = (e: any) => {
    let newItems = [...finishDate];
    let index = e.target.dataset.boxid;

    newItems[index] = {
      ...newItems[index],
      date: e.target.value,
    };

    setFinishDate([...newItems]);
  };

  //출하

  const BoxTermination = (manageBoxId: number) => {
    setManBoxid(manageBoxId);
    setChulmodal(true);
  };

  const chulfunc = useCallback(
    async (type: string) => {
      if (type === "YES") {
        axios
          .put(
            `/ifactory/api/managebox/finish/${manBoxid}?finishDate=${
              finishDate[manBoxid]?.date ?? ""
            }`
          )
          .then((res) => {
            AllData();
            confirmAlert({
              title: res.data,
              buttons: [
                {
                  label: "Yes",
                },
              ],
            });
          })
          .catch((error) => {
            return confirmAlert({
              title: error.response.data.message,
              buttons: [
                {
                  label: "Yes",
                },
              ],
            });
          });
        setChulmodal(false);
      } else if (type === "NO") {
        setChulmodal(false);
      }
    },
    [manBoxid]
  );

  // 예정일변경
  const exchangeTermination = (manageBoxId: number) => {
    axios
      .put(`/ifactory/api/managebox/expdate/${manageBoxId}`, {
        expDate: changeexday[manageBoxId]?.date ?? "",
      })
      .then((res: any) => {
        setExchangeComplete(true);
        confirmAlert({
          title: res.data,
          buttons: [{ label: "Yes" }],
        });
      })
      .catch((error) => {
        return confirmAlert({
          title: error.response.data.message,
          buttons: [
            {
              label: "Yes",
            },
          ],
        });
      });
  };

  useEffect(() => {
    if (exchangeComplete) {
      setExchangeComplete(false);
      setActionComplete(true);
      closeModal();
    }
  }, [exchangeComplete]);

  const MoveBox = (manageBox: any) => {
    setModal(1);
    setManageBox(manageBox);
  };

  // 삭제
  const DeleteBox = (manageBox: any) => {
    setDeletemodal(true);
    setManageBox(manageBox);
  };

  const deletefunc = useCallback(
    async (type: string) => {
      if (type === "YES") {
        axios
          .delete(`ifactory/api/managebox/${manageBox.manageBoxId}`)
          .then((res) => {
            confirmAlert({
              title: res.data,
              buttons: [
                {
                  label: "Yes",
                  onClick: () => {
                    setDeletemodal(false);
                    setActionComplete(true);
                  },
                },
              ],
            });
          })
          .catch((error) => {
            return confirmAlert({
              title: error.response.data.message,
              buttons: [{ label: "Yes" }],
            });
          });
      } else {
        setDeletemodal(false);
      }
    },
    [manageBox]
  );

  const ChangeBox = (manageBox: any) => {
    setModal(2);
    setChangeBoxInfo(manageBox);
  };

  const changeexdayfunc = (e: any) => {
    let newItems = [...changeexday];
    let index = e.target.dataset.boxid;
    newItems[index] = {
      ...newItems[index],
      date: e.target.value,
    };
    setChangeexday([...newItems]);
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setBoxName(event.target.value);
  };

  const fnChangeView = (event: any) => {
    setViewType(!viewType);
    setViewBox(false);
  };
  const fnChOrder1 = (event: any) => {
    setOrderType1(!orderType1);
    setOrderType("1");
    sortAllData("1");
  };
  const fnChOrder2 = (event: any) => {
    setOrderType2(!orderType2);
    setOrderType("2");
    sortAllData("2");
  };
  const fnChOrder3 = (event: any) => {
    setOrderType3(!orderType3);
    setOrderType("3");
    sortAllData("3");
  };

  const handleClick = (event: any) => {
    AllData();
  };

  const viewBoxClick = (manageBox: any) => {
    setSubBoxId(manageBox);
    setViewBox(true);
  };

  return (
    <styles.Container>
      <styles.PageTop>
        <p className="move-btn">
          <img
            src="./img/ArrowLeft.svg"
            alt="좌향버튼"
            onClick={() => {
              navigate("/SelectSetting");
            }}
          />
        </p>
        <p className="pagetit">기본설정</p>
      </styles.PageTop>
      <styles.PageTitle style={{ display: "flex" }}>
        <div className="title">
          <p>상자 관리</p>
          <button
            onClick={() => {
              navigate("/BoxAdd");
            }}
          >
            상자 추가
          </button>
          {/* <button onClick={() => { navigate("/BoxAddAll") }}>일괄 상자 추가</button> */}
        </div>
      </styles.PageTitle>

      <styles.Boxsearch>
        <p className="item-title" style={{ display: "inline-block" }}>
          {targetFarmInfoMemo.name}
        </p>
        <SearchBox style={{ marginLeft: 60 }}>
          <SearchInput
            type="text"
            placeholder="상자 이름 검색"
            value={boxName}
            onChange={handleSearchChange}
          />
          <SearchButton onClick={handleClick}>검색</SearchButton>
        </SearchBox>
      </styles.Boxsearch>
      <styles.Boxsearch>
        <OrderBox onClick={fnChOrder1}>
          상자번호
          {orderType1 ? <UpShape></UpShape> : <DownShape></DownShape>}
        </OrderBox>
        <OrderBox onClick={fnChOrder2}>
          {" "}
          사육시작일
          {orderType2 ? <UpShape></UpShape> : <DownShape></DownShape>}
        </OrderBox>
        <OrderBox onClick={fnChOrder3}>
          {" "}
          출하예정일
          {orderType3 ? <UpShape></UpShape> : <DownShape></DownShape>}
        </OrderBox>
        <div onClick={fnChangeView} style={{ display: "inline-block" }}>
          {!viewType ? <ListButton></ListButton> : <BoxButton></BoxButton>}
        </div>
      </styles.Boxsearch>
      {/* alldata의 lenhth가 0이라면 상자가 없습니다. */}
      {alldata && alldata.length === 0 && (
        <styles.NoData>
          <p>상자가 없습니다.</p>
        </styles.NoData>
      )}

      {alldata &&
        !viewType &&
        alldata.map((containerlist: any, idx: number) => {
          const boxName = containerlist.boxName;
          const boxId = containerlist.manageBoxId;
          const startday = dayjs(containerlist.startFarmDate).format(
            "YYYY년 MM월 DD일"
          );
          const exdays = dayjs(containerlist.expFarmDate).format("YYYY-MM-DD");

          return (
            <styles.BoxItemBox key={idx}>
              <p className="item-title">{boxName}</p>
              <div className="box-list">
                <BoxHeader>
                  <li>사육 시작일 : {startday}</li>
                  <li>출하 예정일 : {exdays}</li>
                  <li className="box-product-name">{`${containerlist.productName} (${containerlist.instarName})`}</li>
                </BoxHeader>

                <div className="box-content">
                  <div className="box-date">
                    <span style={{ marginRight: 10 }}>예정일 변경:</span>
                    <input
                      type="date"
                      style={{ height: 40, marginRight: 30 }}
                      data-boxid={boxId}
                      onChange={changeexdayfunc}
                    />
                    <button onClick={() => exchangeTermination(boxId)}>
                      변경하기
                    </button>
                  </div>
                  <div className="box-date">
                    <span style={{ marginRight: 10 }}>출하일:</span>
                    <input
                      type="date"
                      style={{ height: 40, marginRight: 30 }}
                      data-boxid={boxId}
                      onChange={finishDateHandler}
                    />
                    <button onClick={() => BoxTermination(boxId)}>출하</button>
                  </div>
                  <BtnBox>
                    <button onClick={() => MoveBox(containerlist)}>이동</button>
                    <button onClick={() => DeleteBox(containerlist)}>
                      삭제
                    </button>
                    <button onClick={() => ChangeBox(containerlist)}>
                      상자 곤충명 수정
                    </button>
                  </BtnBox>
                </div>
              </div>
            </styles.BoxItemBox>
          );
        })}

      {alldata && viewType ? (
        <styles.BoxItemBox>
          <div style={{ padding: "10px" }}>
            {alldata &&
              viewType &&
              alldata.map((containerlist: any, idx: number) => {
                const boxName = containerlist.boxName;
                const boxId = containerlist.manageBoxId;
                const startday = dayjs(containerlist.startFarmDate).format(
                  "YYYY년 MM월 DD일"
                );
                const exdays = dayjs(containerlist.expFarmDate).format(
                  "YYYY-MM-DD"
                );

                return (
                  <div style={{ width: "20%", display: "inline-block" }}>
                    <p
                      className="item-title"
                      onClick={() => viewBoxClick(idx)}
                      style={{
                        textAlign: "center",
                        color: "white",
                        backgroundColor: "#73972c",
                        borderRadius: "5px",
                        border: "2px solid black",
                        margin: "10px 20px",
                        padding: "10px 5px",
                        cursor: "pointer",
                      }}
                    >
                      {boxName}
                    </p>
                  </div>
                );
              })}
          </div>
          {viewBox ? (
            <div>
              <p className="item-title">{alldata[subBoxId]["boxName"]}</p>
              <div className="box-list">
                <BoxHeader>
                  <li>
                    사육 시작일 :{" "}
                    {dayjs(alldata[subBoxId]["startFarmDate"]).format(
                      "YYYY년 MM월 DD일"
                    )}
                  </li>
                  <li>
                    출하 예정일 :{" "}
                    {dayjs(alldata[subBoxId]["expFarmDate"]).format(
                      "YYYY-MM-DD"
                    )}
                  </li>
                  <li className="box-product-name">{`${alldata[subBoxId]["productName"]} (${alldata[subBoxId]["instarName"]})`}</li>
                </BoxHeader>

                <div className="box-content">
                  <div className="box-date">
                    <span style={{ marginRight: 10 }}>예정일 변경:</span>
                    <input
                      type="date"
                      style={{ height: 40, marginRight: 30 }}
                      data-boxid={alldata[subBoxId].manageBoxId}
                      onChange={changeexdayfunc}
                    />
                    <button
                      onClick={() =>
                        exchangeTermination(alldata[subBoxId].manageBoxId)
                      }
                    >
                      변경하기
                    </button>
                  </div>
                  <div className="box-date">
                    <span style={{ marginRight: 10 }}>출하일:</span>
                    <input
                      type="date"
                      style={{ height: 40, marginRight: 30 }}
                      data-boxid={alldata[subBoxId].manageBoxId}
                      onChange={finishDateHandler}
                    />
                    <button
                      onClick={() =>
                        BoxTermination(alldata[subBoxId].manageBoxId)
                      }
                    >
                      출하
                    </button>
                  </div>
                  <BtnBox>
                    <button onClick={() => MoveBox(alldata[subBoxId])}>
                      이동
                    </button>
                    <button onClick={() => DeleteBox(alldata[subBoxId])}>
                      삭제
                    </button>
                    <button onClick={() => ChangeBox(alldata[subBoxId])}>
                      상자 곤충명 수정
                    </button>
                  </BtnBox>
                </div>
              </div>
            </div>
          ) : null}
        </styles.BoxItemBox>
      ) : null}

      {modal === 1 ? (
        <BoxMoving
          setModal={setModal}
          alldata={alldata}
          manageBox={manageBox}
          setActionComplete={setActionComplete}
        />
      ) : null}
      {modal === 2 ? (
        <BoxModify
          setModal={setModal}
          setInsect={setInsect}
          insect={insect}
          changeBoxName={changeBoxName}
          setChangeBoxName={setChangeBoxName}
          changeBoxInfo={changeBoxInfo}
          setActionComplete={setActionComplete}
        />
      ) : null}

      {deletemodal && (
        <Modal
          title={"정말로 삭제하시겠습니까?"}
          first={"예"}
          second={"아니오"}
          firstclick={() => deletefunc("YES")}
          secondclick={() => deletefunc("NO")}
        />
      )}

      {chulmodal && (
        <Modal
          title={"정말로 출하하시겠습니까?"}
          first={"예"}
          second={"아니오"}
          firstclick={() => chulfunc("YES")}
          secondclick={() => chulfunc("NO")}
        />
      )}
    </styles.Container>
  );
};

export default Boxmanagement;

// const box-list-product-name = styled.div`
const BoxHeader = styled.ul`
  li {
    list-style: none;

    margin-bottom: 10px;
  }
  .box-product-name {
    font-size: 1em;
    background-color: #73972c;
    border-radius: 4px;
    padding: 4px 8px;
    color: white;
    display: inline-block;
  }
`;

const SearchBox = styled.div`
  display: flex;
  display: inline-block;
  justify-content: center;
  align-items: center;
  border-radius: "5px";
  border: "1px solid #ddd";
  input {
    padding: 8px 12px;
  }
  button {
    padding: 8px 12px;
    height: auto;
    font-size: revert;
  }
`;

const OrderBox = styled.button`
  display: inline-block;
  background-color: white;
  margin: 0px 20px;
  height: 25px;
  border: 0px solid #73972c;
  cursor: pointer;
  color: black;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 1em;
`;
const UpShape = styled.div`
  display: inline-block;
  width: 0;
  margin-top: -1px;
  /* top: 2px; */
  height: 0;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-bottom: 16px solid green;
`;

const DownShape = styled.div`
  display: inline-block;
  width: 0;
  margin-bottom: -1px;
  /* top: 2px; */
  height: 0;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-top: 16px solid green;
`;

const SearchButton = styled.button`
  width: 80px;
  height: 25px;
  border: 3px solid #73972c;
  border-radius: 5px;
  cursor: pointer;
  background-color: #fff;
  color: black;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 1em;
  font-weight: 500;
  margin: 4px 2px;
  transition-duration: 0.4s;
  padding: 8px 28px;
  &:hover {
    background-color: #f2f2f2;
    color: black;
    cursor: pointer;
  }
`;

const SearchInput = styled.input`
  margin-right: 10px;
  flex-grow: 1;
  border: 3px solid #73972c;
  border-radius: 5px;
`;
const ListButton = styled.div`
  width: 34px;
  position: absolute;
  height: 34px;
  cursor: pointer;
  border-radius: 3px;
  content: "";
  margin-top: -23px;
  background-color: #73972c;
  ::before {
    content: "";
    z-index: 1;
    display: block;
    height: 5px;
    width: 5px;
    position: relative;
    top: 11.5px;
    left: 3.5px;
  }
  ::after {
    content: "";
    display: block;
    background: #73972c;
    width: 28px;
    height: 28px;
    top: 0px;
    left: 3px;
    position: relative;
    box-shadow: 0 5px 0 0 #fff inset, 0 10px 0 0 #73972c inset,
      0 15px 0 0 #fff inset, 0 20px 0 0 #73972c inset, 0 25px 0 0 #fff inset;
  }
`;
const BoxButton = styled.div`
  width: 34px;
  position: absolute;
  height: 34px;
  border-radius: 3px;
  cursor: pointer;
  content: "";
  margin-top: -23px;
  background-color: #73972c;
  ::before {
    content: "";
    z-index: 2;
    display: block;
    height: 26px;
    width: 26px;
    background: #fff;
    position: relative;
    top: 4px;
    left: 4px;
    box-shadow: 0 11px 0 0 #fff inset, 0 16px 0 0 #73972c inset;
  }
  ::after {
    background: #73972c;
    z-index: 2;
    content: "";
    height: 34px;
    position: absolute;
    top: 0px;
    left: 15px;
    width: 4px;
  }
`;
